document.addEventListener("DOMContentLoaded", function() {
  function initSlick() {
    var $track = $('.master-collection-grid__track');

    if ($track.length === 0) {
      return;
    }

    if (typeof $.fn.slick !== 'function') {
      return;
    }

    if ($(window).width() < 769) { // mobile + tablet only
      if (!$track.hasClass('slick-initialized')) {
        $track.slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1.1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    } else {
      if ($track.hasClass('slick-initialized')) {
        $track.slick('unslick');
      }
    }
  }

  initSlick();
  $(window).resize(initSlick);
});
